import utils from "../../../utils";
import {Button} from "primereact/button";
import {SelectButtonCustomer} from "../../shared";

class Init {

    getData = () => {
        return {
            username: '',
            email: '',
            phoneNumber1: '',
            phoneNumber2: '',
            firstName: '',
            lastName: '',
            password: '',
            expiryDate: '',
            typeAuth: '1',
            enabled: 1,
            roles: [],
            teams: [],
            competences: [],
            capacityNormal: 5,
            capacityMax: 10,
            languages: []
        };
    }
    getError = () => {
        return {
            phoneNumber1: '',
            phoneNumber2: '',
            email: '',
            password: '',
            passwordFirst: '',
            teams: '',
            competences: '',
            roles: '',
            languages: ''
        }
    }
    getErrorCompetence = () => {
        return {sources: ''}
    }
    getColumns = () => {
        return [
            {field: 'name', header: 'Name'},
            {field: 'enabled', header: 'Enabled'},
            {field: 'username', header: 'Username'},
            {field:'capacityCurrent',header:'Capacity'},
            {field: 'expiryDate', header: 'ExpiryDate'},
            {field: 'statusUserId', header: 'Status'},
            {field: 'action', header: 'Action'}
        ]
    }
    getColumnsCompetences = () => {
        return [

            {field: 'name', header: 'Name'},
            {field: 'description', header: 'Description'},
            {field: 'sources', header: 'Sources'},
            {field: 'action', header: 'Action'}
        ]
    }
    getColumnsRoles = () => {
        return [
            {field: 'id', header: 'Name'},
            {field: 'description', header: 'Description'}
        ]
    }
    dataFilter = () => {
        return {
            expiryDateMin: null,
            expiryDateMax: null,
            enabled: null,
            statusUserId: 'All status',
        }
    }


    _hundBackfound = (callback,user) => {
        if (user && callback) {
            var pctg = (callback.capacityCurrent && user.capacityMax) ? Math.round((callback.capacityCurrent * 100 / user.capacityMax)) : 0;
            pctg = callback.capacityCurrent >= user.capacityMax ? 100 : pctg;
            pctg = callback.capacityCurrent === 0 ? 0 : pctg;
            user.capacityCurrent = callback.capacityCurrent;
            user.capacity = pctg;
            user.masseProg = pctg < 34 ? 'faible' : (pctg < 67 ? 'normal' : 'volumineux');
            user.statusUserId = callback.connected === 0 ? 'Hors ligne' : callback.statusUser?.description; // {statusUserId: 6, description: "Hors ligne"},
            user.statusId = callback.connected === 0 ? 6 : callback.statusUser?.statusUserId;
            return user;
        }
    }

    mapUserData = (user, showUser, confirmDelete, index) => {
        if (user) {
            var pctg = (user.capacityCurrent && user.capacityMax) ? Math.round((user.capacityCurrent * 100 / user.capacityMax)) : 0;
            pctg = user.capacityCurrent >= user.capacityMax ? 100 : pctg;
            pctg = user.capacityCurrent === 0 ? 0 : pctg;
            return {
                id: index,
                name: user.lastName + ' ' + user.firstName,
                enabled: Number(user.enabled),
                username: user.username,
                expiryDate: utils.formatDateSu(user.expiryDate),
                capacityNormal: user.capacityNormal,
                capacityCurrent: user.capacityCurrent,
                capacity: pctg,
                capacityMax: user.capacityMax,
                masseProg: pctg < 34 ? 'faible' : (pctg < 67 ? 'normal' : 'volumineux'),
                statusUserId: user.connected === 0 ? 'Hors ligne' : user.statusUser?.description, // {statusUserId: 6, description: "Hors ligne"},
                statusId: user.connected === 0 ? 6 : user.statusUser?.statusUserId, //
                action:
                    <div className="p-grid p-justify-center p-align-center">
                        <div className="p-col-">
                            <Button className='p-button-tcs'
                                    onClick={() => {
                                        showUser(user)
                                    }}
                                    icon="bi bi-pencil-square"/>
                        </div>
                        {"  "}
                        <div className="p-col-">
                            <SelectButtonCustomer
                                value={user.enabled ? 'ON' : 'OFF'}
                                onChange={() => confirmDelete(user)}
                            />

                            {/*<Button className='p-button-tcs' onClick={() => {*/}
                            {/*    confirmDelete(user)*/}
                            {/*}} icon={user.enabled ? "bi bi-unlock" : "bi bi-lock-fill"}/>*/}
                        </div>
                    </div>
            }
        }
    }

    getIndexByUsername(username, list) {
        for (var i = 0; i < list.length; i++) {
            if (list[i].username === username) {
                return list[i]
            }
        }
    }

    updateDataCallback = (list, callback, showUser, confirmDelete) => {
        var found = this.getIndexByUsername(callback.username, list)
        if (found === -1) {
            return {}
        }
        let result = this._hundBackfound(callback,found);
        return result;
    }
    getIconstatus = (id) => {
        switch (id) {
            case 1:
                return 'bi bi-check-circle-fill';
                break;
            case 2:
                return 'bi bi-record-circle-fill';
                break;
            case 3:
                return 'bi bi-dash-circle-fill';
                break;
            case 4:
                return 'bi bi-exclamation-circle-fill';
                break;
            case 5://absent
                return 'bi bi-clock-fill';
                break;
            default:
                return 'bi bi-x-circle-fill';
                break;
        }
    }


}

export default new Init();